export const config = {
  navbarHeight: "70px"
}